import { makeGetRequest } from 'owa-ows-gateway';
import { UserSubscriptionResponse } from './UserSubscriptionResponse';

const GET_SUBSCRIPTION_URL: string = 'ows/api/beta/PremiumSubscription';
let getUserSubscriptionPromise: Promise<UserSubscriptionResponse>;

export async function getUserSubscription(): Promise<UserSubscriptionResponse> {
    if (!getUserSubscriptionPromise) {
        getUserSubscriptionPromise = makeGetRequest(GET_SUBSCRIPTION_URL);
    }
    return getUserSubscriptionPromise;
}
